import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MESSAGE_LIST, MESSAGE_ADDEDIT, MESSAGE_GETONE, UPLOAD_IMAGES, USERTYPE_WOP_LIST, MESSAGE_DELETE } from "../../api/constApi";
import { MessageListApi, AddEditMessageApi, GetOneMessageApi, UploadImagesApi,GetAllUserTypeApi, DeleteMessageApi } from "../Services/messageService";

export const uploadedImage = createAsyncThunk(UPLOAD_IMAGES, async (payload) => {
    const response = await UploadImagesApi(payload);
    return response.data;
});

export const messageList = createAsyncThunk(MESSAGE_LIST, async (payload) => {
    const response = await MessageListApi(payload);
    return response.data;
});

export const addEditMessage = createAsyncThunk(MESSAGE_ADDEDIT, async (payload) => {
    const response = await AddEditMessageApi(payload);
    return response.data;
});

export const getOneMessage = createAsyncThunk(MESSAGE_GETONE, async (payload) => {
    const response = await GetOneMessageApi(payload);
    return response.data;
});

export const getAllUserType = createAsyncThunk(USERTYPE_WOP_LIST, async (payload) => {
    const response = await GetAllUserTypeApi(payload);
    return response.data;
});

export const deleteMassage = createAsyncThunk(MESSAGE_DELETE, async (payload) => {
    const response = await DeleteMessageApi(payload);
    return response.data;
});

export const messageSlice = createSlice({
    name: "message",
    initialState: {
        message: null,
        token: null,
        error: null,
        uploadedImages: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(messageList.fulfilled, (state, action) => {
            state.message = action?.payload;
        });
        builder.addCase(addEditMessage.fulfilled, (state, action) => {
            state.message = action?.payload?.Data;
          });
        builder.addCase(uploadedImage.fulfilled, (state, action) => {
            const imageUrls = Array.isArray(action.payload.imageUrls) 
                ? action.payload.imageUrls 
                : [action.payload.imageUrl];
            state.uploadedImages = [...state.uploadedImages, ...imageUrls];
        });
    }
});

export default messageSlice.reducer;